import { GradeReportReq, MyGradeReportData } from '@/types';
import { Request } from '@/utils';

class MyPerformance extends Request {
	getMyGradeReportList(data: GradeReportReq) {
		return this.get<MyGradeReportData[]>({
			url: '/mobile/performance/getMyGradeReportList',
			data
		});
	}
}

export const MyPerformanceApi = new MyPerformance();
